import { KYMW2300Component } from './kymw2300.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { CheckProgressHistoryModel } from './vo/check-progress-history.model';
import { ExecutePrintCompanyDataModel } from './vo/execute-print-company-data.model';
import { ExecutePrintCompanyDataThumbnailModel } from './vo/execute-print-company-data-thumbnail.model';
import { GetPageInfoModel } from './vo/get-page-info.model';

/**
 * 印刷会社用データ出力画面の値を管理するクラス
 *
 * @export KYMW2300Model
 * @class KYMW2300Model
 */
export class KYMW2300Model {

  kymw2300Component: KYMW2300Component;

  public orderCode = String('');                                        // 受注コード
  public mediumType = String('');                                       // 媒体区分
  public coopCode = String('');                                         // 生協コード
  public outputType: string = <string>'0';                                      // 出力方法タイプ(0：全て、1：差分)
  public pageList: Array<any> = new Array<any>();                               // 検索結果一覧
  public selectedTargetProgressNum = String('');                        // 選択された工程番号(出力対象)
  public selectedCompareProgressNum = String('');                       // 選択された工程番号(比較フェーズ)

  /**
   * ページ一覧更新
   *
   * @param {*} data サーバデータ
   * @memberof KYMW2300Model
   */
  public updatePageList(data: any): void {
    if (PlessViewUtilsSub.isEmptyArray(data)) {
      this.kymw2300Component.dialogService.openAlertGetMessage('E0100');
      this.pageList = new Array<any>();
      return;
    }
    this.pageList = data;
    this.pageList.forEach(page => {
      page.Selected = (page.Selected.toLowerCase() === 'true')
    })
  }

  /**
   * GetPageInfoVOを返却する
   *
   * @return GetPageInfoVO
   */
  public getGetPageInfoVO(): GetPageInfoModel {
    const vo: GetPageInfoModel = new GetPageInfoModel();
    vo.orderCode = this.kymw2300Component.txi_OrderCode.selectedOrderCode;
    vo.mediumType = this.kymw2300Component.cmb_Medium.selectedMediumType;
    vo.coopCode = this.kymw2300Component.cmb_Coop.selectedCoopCode;
    vo.progressNum = this.kymw2300Component.cmb_TargetProgress.selectedCodeValue;
    return vo;
  }

  /**
   * ExecutePrintCompanyDataVOを返却する
   *
   * @return ExecutePrintCompanyDataVO
   */
  public getExecutePrintCompanyDataVO(): ExecutePrintCompanyDataModel {
    const vo: ExecutePrintCompanyDataModel = new ExecutePrintCompanyDataModel();
    vo.orderCode = this.kymw2300Component.txi_OrderCode.selectedOrderCode;
    vo.mediumType = this.kymw2300Component.cmb_Medium.selectedMediumType;
    vo.coopCode = this.kymw2300Component.cmb_Coop.selectedCoopCode;
    vo.manuscriptsData = PlessViewUtilsSub.booleanTOString(this.kymw2300Component.ckb_Manuscripts.selected);
    vo.buyerDifferenceList = PlessViewUtilsSub.booleanTOString(this.kymw2300Component.ckb_BuyerDifferenceList.selected);
    vo.editDifferenceList = PlessViewUtilsSub.booleanTOString(this.kymw2300Component.ckb_EditDifferenceList.selected);
    vo.tarProgressNum = this.kymw2300Component.cmb_TargetProgress.selectedCodeValue;
    vo.tarProgressName = this.kymw2300Component.cmb_TargetProgress.selectedCodeName;
    vo.comProgressNum = this.kymw2300Component.cmb_CompareProgress.selectedCodeValue;
    vo.comProgressName = this.kymw2300Component.cmb_CompareProgress.selectedCodeName;
    if (this.outputType === '0') {
      vo.outputType = '0';
      vo.outputName = this.kymw2300Component.rdb_All.label;
    } else {
      vo.outputType = '1';
      vo.outputName = this.kymw2300Component.rdb_Diff.label;
    }
    vo.pageIdList = this.getSelectedPageIdList();
    vo.pageNumList = this.getSelectedPageNumList();
    return vo;
  }

  /**
   * ExecutePrintCompanyDataThumbnaiVOを返却する
   *
   * @return ExecutePrintCompanyDataThumbnaiVO
   */
    public getExecutePrintCompanyDataThumbnaiVO(): ExecutePrintCompanyDataThumbnailModel {
      const vo: ExecutePrintCompanyDataThumbnailModel = new ExecutePrintCompanyDataThumbnailModel();
      vo.orderCode = this.kymw2300Component.txi_OrderCode.selectedOrderCode;
      vo.mediumType = this.kymw2300Component.cmb_Medium.selectedMediumType;
      vo.coopCode = this.kymw2300Component.cmb_Coop.selectedCoopCode;
      vo.manuscriptsData = PlessViewUtilsSub.booleanTOString(this.kymw2300Component.ckb_Manuscripts.selected);
      vo.buyerDifferenceList = PlessViewUtilsSub.booleanTOString(this.kymw2300Component.ckb_BuyerDifferenceList.selected);
      vo.editDifferenceList = PlessViewUtilsSub.booleanTOString(this.kymw2300Component.ckb_EditDifferenceList.selected);
      vo.tarProgressNum = this.kymw2300Component.cmb_TargetProgress.selectedCodeValue;
      vo.tarProgressName = this.kymw2300Component.cmb_TargetProgress.selectedCodeName;
      vo.comProgressNum = this.kymw2300Component.cmb_CompareProgress.selectedCodeValue;
      vo.comProgressName = this.kymw2300Component.cmb_CompareProgress.selectedCodeName;
      if (this.outputType === '0') {
        vo.outputType = '0';
        vo.outputName = this.kymw2300Component.rdb_All.label;
      } else {
        vo.outputType = '1';
        vo.outputName = this.kymw2300Component.rdb_Diff.label;
      }
      vo.pageIdList = this.getSelectedPageIdList();
      vo.pageNumList = this.getSelectedPageNumList();
      return vo;
    }

  /**
   * CheckProgressHistoryVOを返却する
   *
   * @param checkType:1　出力対象、2　比較フェーズ、3　その他
   * @return CheckProgressHistoryVO
   */
  public getCheckProgressHistoryVO(checkType: string): CheckProgressHistoryModel {
    const vo: CheckProgressHistoryModel = new CheckProgressHistoryModel();
    vo.orderCode = this.kymw2300Component.txi_OrderCode.selectedOrderCode;
    vo.mediumType = this.kymw2300Component.cmb_Medium.selectedMediumType;
    vo.checkType = checkType;
    if (checkType === '1') {
      vo.progressNum = this.kymw2300Component.cmb_TargetProgress.selectedCodeValue;
    } else if (checkType === '2') {
      vo.progressNum = this.kymw2300Component.cmb_CompareProgress.selectedCodeValue;
    }
    return vo;
  }

  /**
   * ページ一覧全てチェック、チェック解除処理を行う
   */
  public updatePageListAllSelected(flg: boolean): void {
    for (let i = Number(0); i < this.pageList.length; i++) {
      this.pageList[i].Selected = flg;
    }
  }

  public getSelectedPageIdList(): string {
    let returnString = String('');
    for (let i = Number(0); i < this.pageList.length; i++) {
      if (this.pageList[i].Selected) {
        returnString += this.pageList[i].PageId + ',';
      }
    }
    return returnString;
  }

  /**
   * 出力対象ページ番号リスト取得
   */
  public getSelectedPageNumList(): string {
    let returnString = String('');
    for (let i = Number(0); i < this.pageList.length; i++) {
      if (this.pageList[i].Selected) {
        returnString += Number(this.pageList[i].PageNum) + ',';
      }
    }
    return returnString;
  }

  /**
   * 出力対象ROLLBACK
   */
  public rollBackCmbTargetProgress(object: Object): void {
    this.kymw2300Component.cmb_TargetProgress.setCodeValue(this.selectedTargetProgressNum);
    this.kymw2300Component.updateRadAllDiff();
  }

  /**
   * 比較フェーズROLLBACK
   */
  public rollBackCmbCompareProgress(object: Object): void {
    this.kymw2300Component.cmb_CompareProgress.setCodeValue(this.selectedCompareProgressNum);
    this.kymw2300Component.updateRadAllDiff();
  }
}
